export function getKakaoRedirectUri(location = window.location) {
  return `${location.origin}/auth/kakao/callback`
}

export function startKakaoLogin(location = window.location) {
  const redirectUri = getKakaoRedirectUri(location)
  location.assign(`/api/auth/kakao/start?redirect_uri=${encodeURIComponent(redirectUri)}`)
}

export async function exchangeKakaoCode(code, state, { fetcher = fetch, location = window.location } = {}) {
  const response = await fetcher('/api/auth/kakao', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ code, state, redirectUri: getKakaoRedirectUri(location) }),
  })
  const payload = await response.json().catch(() => ({}))
  if (!response.ok) throw new Error(payload.error || '카카오 로그인 처리 중 오류가 발생했습니다.')
  if (!payload.firebaseToken) throw new Error('Firebase 로그인 토큰을 받지 못했습니다.')
  return payload.firebaseToken
}
